<template>
  <div v-if="isLoadingModuleInfo" class="classSession-preview">
    正在获取闻思记录...
  </div>
  <div v-else>
    <b-tabs pills content-class="mt-3" align="center">
      <b-tab title="未圆满" title-item-class="mytab" acitve>
        <Module
          :showIncompleted="true"
          :parseModule="userModuleInfo.module"
          :moduleDetails="userModuleInfo"
          :submodules="userModuleInfo.submodules"
          @submoduleCompleted="onSubmoduleCompleted"
        />
      </b-tab>
      <b-tab title="已圆满" title-item-class="mytab" acitve>
        <Module
          :parseModule="userModuleInfo.module"
          :moduleDetails="userModuleInfo"
          :submodules="userModuleInfo.completed"
        />
        <b-button block variant="warning" @click="resetSubmodules()"
          >重新开始</b-button
        >
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import store from "@/store";
import { FETCH_MODULE_DETAILS } from "../store/actions.type";
import { mapGetters } from "vuex";
import Module from "@/components/Module";
import Parse from "parse";

export default {
  name: "ModuleInfo",
  components: {
    Module
  },
  computed: {
    ...mapGetters(["isLoadingModuleInfo", "userModuleInfo"])
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch(FETCH_MODULE_DETAILS, to.params).then(() => {
      next();
    });
  },
  methods: {
    onSubmoduleCompleted(value) {
      this.userModuleInfo.completedSubmodules += 1;
      for (var i = 0; i < this.userModuleInfo.submodules.length; i++) {
        const submodule = this.userModuleInfo.submodules[i];
        if (submodule.id == value.submodule.id) {
          this.userModuleInfo.submodules.splice(i, 1);
          submodule.studyRecord = value.result.result;
          for (var j = 0; j < this.userModuleInfo.completed.length; j++) {
            if (submodule.index > this.userModuleInfo.completed[j].index) {
              this.userModuleInfo.completed.splice(j, 0, submodule);
              break;
            }
          }
          break;
        }
      }
    },
    resetSubmodules() {
      var msg = "确认重新开始所有已圆满课程?";

      const options = {
        okText: "确认",
        cancelText: "取消",
        loader: true // default: false - when set to true, the proceed button shows a loader when clicked; and a dialog object will be passed to the then() callback
      };
      const submodules = this.userModuleInfo.completed;
      const message = {
        title: this.userModuleInfo.module.get("name"),
        body: msg
      };
      const thisComponent = this;
      const userStudyRecord = { lineage: false, textbook: false };
      const forDashboard = false;

      this.$dialog
        .confirm(message, options)
        .then(function(dialog) {
          for (var i = 0; i < submodules.length; i++) {
            const submodule = submodules[i];
            Parse.Cloud.run("selfStudy:updateSubmoduleStudyState", {
              submodule,
              userStudyRecord,
              forDashboard
            })
              .then(result => {
                console.log(
                  `updateSubmoduleStudyState - result: ${JSON.stringify(
                    result
                  )}`
                );
                if (i == submodules.length) {
                  dialog.close();
                  window.location.reload();
                }
              })
              .catch(e => {
                console.log(`error in updateSubmoduleStudyState: ${e}`);
                dialog.close();
                thisComponent.$dialog.alert(
                  `error in updateSubmoduleStudyState: ${e}`
                );
              });
          }
        })
        .catch(e => {
          console.log(`error: ${e}`);
        });
    }
  }
};
</script>

<style>
.nav-pills li {
  list-style-type: none;
}

.nav-pills .mytab .nav-link:not(.active) {
  background-color: red !important;
  font-size: 22px;
}

.nav-pills .mytab .nav-link {
  background-color: blue !important;
  font-size: 22px;
}
</style>
